module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTIgOGMwLTIuMjA5MTQtMS43OTA4Ni00LTQtNFM0IDUuNzkwODYgNCA4czEuNzkwODYgNCA0IDQgNC0xLjc5MDg2IDQtNHpNMSA4YzAtMy44NjYgMy4xMzQtNyA3LTdzNyAzLjEzNCA3IDctMy4xMzQgNy03IDctNy0zLjEzNC03LTd6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/pin_icon.svg
// module id = 465
// module chunks = 168707334958949